__turbopack_context__.v({
  "header": "oIyQhG_header",
  "link": "oIyQhG_link",
  "section": "oIyQhG_section",
  "title": "oIyQhG_title",
  "wrap": "oIyQhG_wrap",
});
